export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_35-cc203a9d797f3c6b624abfcd57192e7d.jpg";